import Spinner from "../../components/Spinner";
import Typography from "../../components/Typography";
import { AuthContainer } from "./styles";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { refreshTokenRequest } from "../../store/actions/auth";

const Page = ({}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  
  useEffect(() => {
    const token = location.hash.slice(1);
    if(token) {
      const tokenDecode = decodeURIComponent(token.split('').reverse().join(''));
      dispatch(refreshTokenRequest(tokenDecode, () => {
        navigate("/dashboard/cursos/list", { replace: true });
      }));
    }
  }, [])

  return (
    <AuthContainer>
      <Typography as="h2" size="lg">
        Preparando tu sesión... ¡casi listo! 
      </Typography>
      <Spinner color="Primary"/>
    </AuthContainer>
  );
};

export default Page;